import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { MissionUser } from '../mission-user.model';

@JsonObject('MissionUsersResultsResponse')
export class MissionUsersResultsResponse extends ApiResultsResponse<MissionUser> {

  @JsonProperty('results', [MissionUser])
  override results: MissionUser[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
